module.exports = __webpack_public_path__ + "img/CS48Q-中_17.caa248ff.jpg";